// External Libraries
import React from 'react';
import { Link } from 'react-router-dom';

// Assets
import NoPhoto from '../../assets/no-photo.png';

// Styles
import '../../styles/ProfileCard.css';

// Utilities
import { getUserTypeLogo } from '../../utils/CommonUtils';

// Types
import { ProfileCardProps } from '../../types/types';

// Components
import Text from './Text';

export const ProfileCard: React.FC<ProfileCardProps> = ({
  name,
  position,
  photo,
  userType,
  ideaOwnerId,
  principalInvestigator,
  caseManager,
}) => {
  return (
    <div className="d-flex justify-content-between profile-card">
      <div className="d-flex gap-8">
        <Link
          to={`/profile/${ideaOwnerId}`}
          className="profile-image redirect-link"
        >
          <img
            src={photo !== null && photo?.trim() !== '' ? photo : NoPhoto}
            alt={photo}
            className="photo-logo"
          />
        </Link>
        <div className="d-flex flex-column">
          <Link
            to={`/profile/${ideaOwnerId}`}
            className="medium-bold redirect-link"
          >
            {name}
          </Link>
          {position && <Text className="secondary-text">{position}</Text>}
          {principalInvestigator && (
            <Text className="extra-small-primary">Principal Investigator</Text>
          )}
          {caseManager && (
            <Text className="extra-small-primary">Case Manager</Text>
          )}
        </div>
      </div>
      <div className="user-type">{userType && getUserTypeLogo(userType)}</div>
    </div>
  );
};

export default ProfileCard;
